@import "@/styles/variables";

.wrapper {
	padding: 2rem;
	max-width: 1000px;
	margin: 0 auto;
	font-family: "Inter", sans-serif;
	color: #1f2937;

	.backButton {
		display: inline-flex;
		align-items: center;
		font-size: 0.875rem;
		color: #6b7280;
		background: none;
		border: none;
		cursor: pointer;
		margin-bottom: 1rem;
		transition: color 0.2s;

		&:hover {
			color: #111827;
		}
	}
}

.body {
	background: white;
	border-radius: $border-radius;
	border: 1px solid #e5e7eb;
}

.header {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: 1.5rem;
	background: white;
	padding: 1rem;
	border-radius: $border-radius;
	border: 1px solid #e5e7eb;
}

.title {
	font-size: 2rem;
	font-weight: 600;
	padding-left: 1em;
}

.logoContainer {
	width: 120px;
	height: 120px;
	cursor: pointer;
	border-radius: 0.5rem;
	overflow: hidden;
	border: 2px dashed #d1d5db;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: border-color 0.3s;

	&:hover {
		border-color: #7fb02f;
	}
}

.logo {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.tabs {
	display: flex;
	gap: 1rem;
	border-bottom: 2px solid #e5e7eb;
	padding: 1rem;
	padding-bottom: 0px;
}

.tabButton {
	background: transparent;
	border: none;
	padding: 0.5rem 1rem;
	font-size: 1rem;
	cursor: pointer;
	border-bottom: 2px solid transparent;
	transition:
		border-color 0.2s,
		color 0.2s;
	color: #6b7280;
	margin-bottom: -2px;
	padding-bottom: 1rem;

	&:hover {
		color: #111827;
	}
}

.active {
	color: #111827;
	border-bottom-color: #7fb02f;
	font-weight: 500;
}

.tabContent {
	padding: 1rem;
	margin-top: 1.2rem;
}

.actions {
	padding: 1rem;
	border-top: 1px solid #e5e7eb;

	margin-top: 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
}

.leftActions {
	display: flex;
	gap: 0.5rem;
}
